import { MakeCall } from 'ha/services/apiV2/createMakeCall';
import { Conversation } from './types/Conversation';
import { APIV2_URL } from './constants';

export interface Payload {
  listingId: number;
  startDate: string;
  endDate: string;
  messageText: string;
  instantBooking?: boolean;
  adProvider?: string;
  adClickID?: string;
}

export default (makeCall: MakeCall) => (
  data: Payload,
  rentalConditionsEnabled: boolean,
) => {
  const headers = rentalConditionsEnabled
    ? { 'X-HA-Features': 'rentalConditions' }
    : {};

  return makeCall<Conversation>('POST', `${APIV2_URL}/conversation`, {
    data,
    headers,
  });
};
